import React, { useState } from "react";
import Phone from "../../../../Components/Inputs/Phone";
import Password from "../../../../Components/Inputs/Password";

import Email from "../../../../Components/Inputs/Email";
import { TextField } from "@mui/material";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";

import "./SignupForm.scss";

export default function SignupForm({ handleSubmit }) {
  const [phone, setPhone] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [confirmPassword, setConfirmPassword] = useState<string>("");

  const handleSubmitForm = (e) => {
    e.preventDefault();
    if (password && password === confirmPassword) {
      handleSubmit(e, { phone, password });
    }
  };
  const handleChange = (e) => {
    switch (e.target.id) {
      case "phone":
        setPhone(e.target.value);
        break;
      case "password":
        setPassword(e.target.value);
        break;
      case "confirm_password":
        setConfirmPassword(e.target.value);
        break;
      default:
        break;
    }
  };

  const handlePasswordShow = () => {
    setShowPassword((preState) => !preState);
  };
  return (
    <div className="signup_info">
      <h3>Sign Up</h3>
      <form onSubmit={handleSubmitForm}>
        <div className=" input_wrapper">
          {/* <Phone placeholder={"Phone"} className="input_field" id="phone" value={phone} onChange={handleChange} /> */}
          <TextField id="phone" label="Phone" variant="outlined" onChange={handleChange} value={phone} fullWidth />
        </div>
        <div className="input_wrapper">
          <TextField id="password" label="Password" type={showPassword ? "password" : ""} variant="outlined" onChange={handleChange} value={password} fullWidth />
          <div className="password_icon" onClick={handlePasswordShow}>
            {showPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
          </div>
        </div>
        <div className="input_wrapper">
          <TextField id="confirm_password" label="Confirm Password" type={showPassword ? "password" : ""} variant="outlined" onChange={handleChange} value={confirmPassword} helperText={!(password === confirmPassword) ? "Password doesn't match" : ""} fullWidth />
          <div className="password_icon">{showPassword ? <AiFillEyeInvisible /> : <AiFillEye />}</div>
        </div>
        <button className="button button_primary"> Sign-up</button>
      </form>
    </div>
  );
}
